(function(){
  "use strict";

  /* Görsel/logo placeholder yardımcıları — gerçek CDN görselleriyle değiştirilecek */
  const ph = t => 'https://placehold.co/600x400/e5e7eb/6b7280?text=' + encodeURIComponent(t);
  const lg = t => 'https://placehold.co/240x120/1d1d1f/ffffff?text=' + encodeURIComponent(t);

  /* ===== VERİTABANI (orijinalden korunmuştur) ===== */
  const EV_DB = [
    {brand:"Alfa Romeo", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/current-badge_457d965994803bd415fc9735d023d1eb.png?v=1763721103",
      models:[{name:"Junior Elettrica", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Alfa+Junior", bat:54.0, ac:11}]},
    {brand:"Audi", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/images.png?v=1755631203",
      models:[
        {name:"e-tron 55", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Audi+e-tron", bat:95.0, ac:11},
        {name:"Q8 e-tron 55", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Audi+Q8", bat:114.0, ac:11},
        {name:"Q4 e-tron", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Audi+Q4", bat:82.0, ac:11},
        {name:"e-tron GT", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Audi+GT", bat:93.4, ac:11}]},
    {brand:"BMW", logo:"https://upload.wikimedia.org/wikipedia/commons/f/f4/BMW_logo_%28gray%29.svg",
      models:[
        {name:"iX1 eDrive20", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=BMW+iX1", bat:66.5, ac:22},
        {name:"iX2 eDrive20", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=BMW+iX2", bat:64.8, ac:22},
        {name:"i4 eDrive40", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/bmw-i4-gran-coupe-modelfinder_1.png?v=1755681317", bat:83.9, ac:11},
        {name:"iX3", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=BMW+iX3", bat:80.0, ac:11},
        {name:"iX xDrive40", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=BMW+iX", bat:76.6, ac:11},
        {name:"i5 eDrive40", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/i5-bev.png?v=1763722635", bat:81.2, ac:22}]},
    {brand:"BYD", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/byd-logo-png_seeklogo-546145.png?v=1755631203",
      models:[
        {name:"Atto 3", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/kar-beyazi.png?v=1755699772", bat:60.48, ac:11},
        {name:"Seal U EV", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/karbon-siyah2.png?v=1755699368", bat:87.0, ac:11},
        {name:"Han", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/s9-car-2.png?v=1763722088", bat:85.4, ac:11},
        {name:"Sealion 7", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/atgreyv1.png?v=1763722042", bat:82.5, ac:11},
        {name:"Dolphin", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/byd-dolphin-2024-0175.png?v=1763722128", bat:60.4, ac:11}]},
    {brand:"Chery", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/chery-logo-png_seeklogo-215310.png?v=1755631203",
      models:[{name:"Omoda 5 EV", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Chery+Omoda+5", bat:61.0, ac:9.9}]},
    {brand:"Citroen", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/citroen-logo-png_seeklogo-245134.png?v=1755631203",
      models:[
        {name:"e-C4", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Citroen+e-C4", bat:50.0, ac:7.4},
        {name:"ë-C3 Aircross", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Citroen+e-C3+Aircross", bat:44.0, ac:11},
        {name:"Ami", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Citroen+Ami", bat:5.5, ac:2.3}]},
    {brand:"Dacia", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/dacia-logo-png_seeklogo-426000.png?v=1755631204",
      models:[{name:"Spring", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Dacia+Spring", bat:26.8, ac:6.6}]},
    {brand:"DS", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/ds-automobiles-logo-png_seeklogo-474217.png?v=1763724916",
      models:[{name:"3 E-Tense", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=DS+3", bat:54.0, ac:11}]},
    {brand:"Fiat", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/fiat-logo-png_seeklogo-534934.png?v=1755631203",
      models:[{name:"500e", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Fiat+500e", bat:42.0, ac:11}]},
    {brand:"Ford", logo:"https://upload.wikimedia.org/wikipedia/commons/3/3e/Ford_logo_flat.svg",
      models:[
        {name:"Mustang Mach-E", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Ford+Mustang", bat:75.7, ac:11},
        {name:"E-Transit", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Ford+E-Transit", bat:74.0, ac:11}]},
    {brand:"Hongqi", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/images_9023db14-c253-4927-8a0f-a86f217f1aea.jpg?v=1763724951",
      models:[{name:"E-HS9", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Hongqi+E-HS9", bat:99.0, ac:11}]},
    {brand:"Hyundai", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/hyundai-logo-png_seeklogo-309777.png?v=1755631203",
      models:[
        {name:"IONIQ 5", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Hyundai+IONIQ+5", bat:77.4, ac:11},
        {name:"IONIQ 6", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Hyundai+IONIQ+6", bat:77.4, ac:11},
        {name:"Kona EV", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Hyundai+Kona", bat:65.4, ac:11}]},
    {brand:"Jaguar", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/jaguar-logo-png_seeklogo-486031.png?v=1755631204",
      models:[{name:"I-PACE", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Jaguar+I-PACE", bat:90.0, ac:11}]},
    {brand:"Jeep", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/jeep-logo-png_seeklogo-75284.png?v=1763721097",
      models:[{name:"Avenger", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Jeep+Avenger", bat:54.0, ac:11}]},
    {brand:"KGM (SsangYong)", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/ssangyong-logo-png_seeklogo-131219.png?v=1763721098",
      models:[
        {name:"Torres EVX", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/torres-evx-iron-metal66a9e034350f0-1-e1744985886274.png?v=1763722488", bat:73.4, ac:11},
        {name:"Korando e-Motion", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/space-black.png?v=1763722547", bat:61.5, ac:6.6}]},
    {brand:"Kia", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/images_f964fdc4-9dfb-4901-94fd-0ce26152b7d0.png?v=1755631621",
      models:[
        {name:"EV6", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Kia+EV6", bat:77.4, ac:11},
        {name:"EV9", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Kia+EV9", bat:99.8, ac:11},
        {name:"Niro EV", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Kia+Niro+EV", bat:64.8, ac:11},
        {name:"EV3", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Kia+EV3", bat:81.4, ac:11}]},
    {brand:"Leapmotor", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/Leapmotor_logo.png?v=1763721104",
      models:[{name:"T03", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Leapmotor+T03", bat:41.3, ac:6.6}]},
    {brand:"Lexus", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/lexus-logo-png_seeklogo-83673.png?v=1755631621",
      models:[
        {name:"RZ 450e", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Lexus+RZ", bat:71.4, ac:11},
        {name:"UX 300e", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Lexus+UX", bat:72.8, ac:6.6}]},
    {brand:"Lotus", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/lotus-cars-logo-png_seeklogo-345267.png?v=1763725000",
      models:[{name:"Eletre", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Lotus+Eletre", bat:112.0, ac:22}]},
    {brand:"Mercedes-Benz", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/mercedes-benz-logo-png_seeklogo-332844.png?v=1755631621",
      models:[
        {name:"EQA 250+", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/mercedes-benz-eqa.png?v=1763723176", bat:70.5, ac:11},
        {name:"EQB 250+", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/2025_24.avif?v=1763723176", bat:70.5, ac:11},
        {name:"EQE SUV", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/eqe-class-saloon-v295-4q9zdh4c3y-320.png?v=1763723176", bat:90.6, ac:22},
        {name:"EQS SUV", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/Front_kC3SCiu.png.1000x1000_q95.png?v=1763723177", bat:118.0, ac:22},
        {name:"EQE 350+", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/eqe-class-saloon-v295-4q9zdh4c3y-320.png?v=1763723176", bat:90.6, ac:22},
        {name:"EQS 450+", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/Front_kC3SCiu.png.1000x1000_q95.png?v=1763723177", bat:108.4, ac:22}]},
    {brand:"MG", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/mg-logo-png_seeklogo-91883.png?v=1755631621",
      models:[
        {name:"MG4 Luxury", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/mg-4.png?v=1763722717", bat:64.0, ac:11},
        {name:"ZS EV", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/ZS-Black.png?v=1763722717", bat:72.0, ac:11}]},
    {brand:"Mini Cooper", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/mini-cooper-logo-png_seeklogo-224659.png?v=1755631621",
      models:[
        {name:"Cooper SE", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Mini+Cooper+SE", bat:32.6, ac:11},
        {name:"Countryman SE", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Mini+Countryman", bat:66.5, ac:22},
        {name:"Aceman SE", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Mini+Aceman", bat:54.2, ac:11}]},
    {brand:"Nissan", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/nissan-2020-logo-png_seeklogo-383848.png?v=1763724746",
      models:[{name:"Ariya", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Nissan+Ariya", bat:87.0, ac:22}]},
    {brand:"Opel", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/opel-logo-png_seeklogo-103491.png?v=1755631621",
      models:[
        {name:"Mokka-e", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Opel+Mokka", bat:54.0, ac:11},
        {name:"Corsa-e", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Opel+Corsa", bat:51.0, ac:11},
        {name:"Astra-e", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Opel+Astra", bat:54.0, ac:11}]},
    {brand:"Peugeot", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/peugeot-new-2021-logo-png_seeklogo-398828.png?v=1755631621",
      models:[
        {name:"e-2008", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Peugeot+e-2008", bat:54.0, ac:11},
        {name:"e-3008", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Peugeot+e-3008", bat:73.0, ac:11},
        {name:"e-208", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Peugeot+e-208", bat:51.0, ac:7.4}]},
    {brand:"Porsche", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/porsche-logo-png_seeklogo-399884.png?v=1755631621",
      models:[
        {name:"Taycan 4S", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Porsche+Taycan", bat:93.4, ac:11},
        {name:"Macan Electric", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Porsche+Macan", bat:100.0, ac:11}]},
    {brand:"Renault", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/renault-logo-png_seeklogo-264207.png?v=1755631621",
      models:[
        {name:"Megane E-Tech", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Renault+Megane", bat:60.0, ac:22},
        {name:"Zoe", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Renault+Zoe", bat:52.0, ac:22},
        {name:"Scenic E-Tech", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Renault+Scenic", bat:87.0, ac:22}]},
    {brand:"Seres", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/Seres-logo.png?v=1763724847",
      models:[{name:"Seres 3", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Seres+3", bat:53.6, ac:6.6}]},
    {brand:"Skywell", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/skywell-auto-new-logo-png_seeklogo-535372.png?v=1755631621",
      models:[{name:"ET5 LR", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Skywell+ET5", bat:86.0, ac:11}]},
    {brand:"Subaru", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/images_84068046-2aea-4122-aa88-9e5da06c59c3.jpg?v=1755631621",
      models:[{name:"Solterra", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Subaru+Solterra", bat:71.4, ac:7}]},
    {brand:"Tesla", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/tesla-logo-png_seeklogo-365010.png?v=1755631621",
      models:[
        {name:"Model Y RWD", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/Tesla-Model-Y-Transparent-PNG.png?v=1755698961", bat:60.0, ac:11},
        {name:"Model Y LR", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/Tesla-Model-Y-Transparent-PNG.png?v=1755698961", bat:75.0, ac:11},
        {name:"Model 3", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Tesla+Model+3", bat:60.0, ac:11},
        {name:"Model Y Juniper", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/tesla-model-y-facelift-2025-15_jpg.webp?v=1763722272", bat:62.5, ac:11}]},
    {brand:"Togg", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/togg-logo-png_seeklogo-427242.png?v=1755631202",
      models:[
        {name:"T10X V1", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/togg.jpg?v=1755698956", bat:52.4, ac:11},
        {name:"T10X V2", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/togg.jpg?v=1755698956", bat:88.5, ac:22},
        {name:"T10F", img:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/68beb224450a990a0823985f_T10F-smart-connected.webp?v=1763722192", bat:88.5, ac:22}]},
    {brand:"Toyota", logo:"https://upload.wikimedia.org/wikipedia/commons/9/9d/Toyota_carlogo.svg",
      models:[{name:"bZ4X", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Toyota+bZ4X", bat:71.4, ac:11}]},
    {brand:"Volkswagen", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/volkswagen-logo-png_seeklogo-360399.png?v=1755631621",
      models:[
        {name:"ID.3", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=VW+ID.3", bat:58.0, ac:11},
        {name:"ID.4", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=VW+ID.4", bat:77.0, ac:11},
        {name:"ID.5", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=VW+ID.5", bat:77.0, ac:11},
        {name:"e-Golf", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=VW+e-Golf", bat:35.8, ac:7.2}]},
    {brand:"Volvo", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/volvo-new-2021-logo-png_seeklogo-412110.png?v=1755631621",
      models:[
        {name:"EX30 Single", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Volvo+EX30", bat:51.0, ac:11},
        {name:"C40 Recharge", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Volvo+C40", bat:78.0, ac:11},
        {name:"XC40 Recharge", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Volvo+XC40", bat:78.0, ac:11},
        {name:"EX90", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Volvo+EX90", bat:111.0, ac:11}]},
    {brand:"Voyah", logo:"https://cdn.shopify.com/s/files/1/0858/8551/8142/files/Voyah-Logo.jpg?v=1763724798",
      models:[{name:"Free", img:"https://placehold.co/600x400/e5e7eb/6b7280?text=Voyah+Free", bat:106.0, ac:11}]}
  ];

  /* ===== EK MARKA & MODELLER =====
     Spesifikasyonlar (batarya kWh / AC kW) güncel verilere göredir.
     Görsel ve logolar PLACEHOLDER'dır — Shopify CDN'e yükleyip gerçek URL'lerle değiştirin.
     Mevcut markaya eklenen modeller otomatik birleşir; yeni markalar listeye eklenir. */
  const EV_DB_ADD = [
    // --- Yeni markalar ---
    {brand:"Cupra", logo:lg("Cupra"), models:[
      {name:"Born", img:ph("Cupra Born"), bat:59.0, ac:11},
      {name:"Tavascan", img:ph("Cupra Tavascan"), bat:77.0, ac:11}]},
    {brand:"Skoda", logo:lg("Skoda"), models:[
      {name:"Enyaq 85", img:ph("Skoda Enyaq"), bat:82.0, ac:11},
      {name:"Elroq 85", img:ph("Skoda Elroq"), bat:77.0, ac:11}]},
    {brand:"Polestar", logo:lg("Polestar"), models:[
      {name:"Polestar 2", img:ph("Polestar 2"), bat:82.0, ac:11},
      {name:"Polestar 3", img:ph("Polestar 3"), bat:111.0, ac:11},
      {name:"Polestar 4", img:ph("Polestar 4"), bat:100.0, ac:22}]},
    {brand:"Smart", logo:lg("Smart"), models:[
      {name:"#1", img:ph("Smart #1"), bat:66.0, ac:22},
      {name:"#3", img:ph("Smart #3"), bat:66.0, ac:22}]},
    {brand:"Genesis", logo:lg("Genesis"), models:[
      {name:"GV60", img:ph("Genesis GV60"), bat:77.4, ac:11},
      {name:"Electrified GV70", img:ph("Genesis GV70"), bat:77.4, ac:11},
      {name:"Electrified G80", img:ph("Genesis G80"), bat:87.2, ac:11}]},
    {brand:"Honda", logo:lg("Honda"), models:[
      {name:"e:Ny1", img:ph("Honda e-Ny1"), bat:68.8, ac:11}]},
    {brand:"Mazda", logo:lg("Mazda"), models:[
      {name:"MX-30", img:ph("Mazda MX-30"), bat:35.5, ac:6.6},
      {name:"6e", img:ph("Mazda 6e"), bat:80.0, ac:11}]},
    {brand:"Xpeng", logo:lg("Xpeng"), models:[
      {name:"G6", img:ph("Xpeng G6"), bat:87.5, ac:11},
      {name:"G9", img:ph("Xpeng G9"), bat:98.0, ac:11},
      {name:"P7", img:ph("Xpeng P7"), bat:86.2, ac:11}]},
    {brand:"Zeekr", logo:lg("Zeekr"), models:[
      {name:"001", img:ph("Zeekr 001"), bat:100.0, ac:22},
      {name:"X", img:ph("Zeekr X"), bat:66.0, ac:22},
      {name:"7X", img:ph("Zeekr 7X"), bat:75.0, ac:11}]},
    {brand:"Maserati", logo:lg("Maserati"), models:[
      {name:"Grecale Folgore", img:ph("Maserati Grecale"), bat:105.0, ac:22},
      {name:"GranTurismo Folgore", img:ph("Maserati GranTurismo"), bat:92.5, ac:22}]},
    {brand:"Cadillac", logo:lg("Cadillac"), models:[
      {name:"Lyriq", img:ph("Cadillac Lyriq"), bat:102.0, ac:11},
      {name:"Optiq", img:ph("Cadillac Optiq"), bat:85.0, ac:11}]},
    {brand:"Maxus", logo:lg("Maxus"), models:[
      {name:"Mifa 9", img:ph("Maxus Mifa 9"), bat:90.0, ac:11},
      {name:"T90 EV", img:ph("Maxus T90 EV"), bat:88.5, ac:11}]},
    {brand:"Ora", logo:lg("Ora"), models:[
      {name:"03", img:ph("Ora 03"), bat:63.0, ac:11}]},

    // --- Mevcut markalara eklenen modeller ---
    {brand:"Tesla", models:[
      {name:"Model S", img:ph("Tesla Model S"), bat:100.0, ac:11},
      {name:"Model X", img:ph("Tesla Model X"), bat:100.0, ac:11}]},
    {brand:"Audi", models:[
      {name:"Q6 e-tron", img:ph("Audi Q6 e-tron"), bat:94.9, ac:11},
      {name:"A6 e-tron", img:ph("Audi A6 e-tron"), bat:94.9, ac:11}]},
    {brand:"BMW", models:[
      {name:"i7 xDrive60", img:ph("BMW i7"), bat:101.7, ac:11}]},
    {brand:"Mercedes-Benz", models:[
      {name:"G 580 EQ", img:ph("Mercedes G 580"), bat:116.0, ac:11}]},
    {brand:"Hyundai", models:[
      {name:"Inster", img:ph("Hyundai Inster"), bat:49.0, ac:11},
      {name:"IONIQ 9", img:ph("Hyundai IONIQ 9"), bat:110.3, ac:11}]},
    {brand:"Kia", models:[
      {name:"EV4", img:ph("Kia EV4"), bat:81.4, ac:11},
      {name:"EV5", img:ph("Kia EV5"), bat:88.1, ac:11}]},
    {brand:"Renault", models:[
      {name:"5 E-Tech", img:ph("Renault 5"), bat:52.0, ac:11},
      {name:"4 E-Tech", img:ph("Renault 4"), bat:52.0, ac:11}]},
    {brand:"Fiat", models:[
      {name:"600e", img:ph("Fiat 600e"), bat:54.0, ac:11},
      {name:"Grande Panda", img:ph("Fiat Grande Panda"), bat:44.0, ac:11}]},
    {brand:"Citroen", models:[
      {name:"ë-C3", img:ph("Citroen e-C3"), bat:44.0, ac:11}]},
    {brand:"Peugeot", models:[
      {name:"e-308", img:ph("Peugeot e-308"), bat:54.0, ac:11},
      {name:"e-408", img:ph("Peugeot e-408"), bat:58.0, ac:11},
      {name:"e-5008", img:ph("Peugeot e-5008"), bat:73.0, ac:11}]},
    {brand:"Volkswagen", models:[
      {name:"ID.7", img:ph("VW ID.7"), bat:77.0, ac:11},
      {name:"ID. Buzz", img:ph("VW ID Buzz"), bat:79.0, ac:11}]},
    {brand:"MG", models:[
      {name:"MG5 EV", img:ph("MG5 EV"), bat:61.1, ac:11},
      {name:"Cyberster", img:ph("MG Cyberster"), bat:77.0, ac:11},
      {name:"MGS5 EV", img:ph("MGS5 EV"), bat:62.0, ac:11}]},
    {brand:"BYD", models:[
      {name:"Seal", img:ph("BYD Seal"), bat:82.5, ac:11},
      {name:"Tang", img:ph("BYD Tang"), bat:108.8, ac:11},
      {name:"Atto 2", img:ph("BYD Atto 2"), bat:45.1, ac:11},
      {name:"Dolphin Surf", img:ph("BYD Dolphin Surf"), bat:43.2, ac:11}]}
  ];

  // Birleştir: mevcut markaya modelleri ekle, yeni markaları listeye koy
  EV_DB_ADD.forEach(add => {
    const ex = EV_DB.find(b => b.brand === add.brand);
    if (ex) { ex.models = ex.models.concat(add.models); }
    else { EV_DB.push(add); }
  });

  /* ===== ŞARJ CİHAZLARI =====
     tier: kapasite sınıfı | flagship: o sınıftaki birincil öneri | portable: taşınabilir mi */
  const CHARGERS = [
    // 22 kW DUVAR TİPİ — flagship: WTA (her zaman önerilen duvar tipi)
    {name:'WiseCar WTA 22 kW',    power_kw:22,  tier:22,  flagship:true,  portable:false, image_url:'https://cdn.shopify.com/s/files/1/0858/8551/8142/files/apwta.png?v=1762757542', link:'https://wisecar.com.tr/products/wisecar-wta-22kw-elektrikli-arac-sarj-cihazi-ev-wallbox-type-2'},
    {name:'WiseCar WTL 22 kW',    power_kw:22,  tier:22,  flagship:false, portable:false, image_url:'https://cdn.shopify.com/s/files/1/0858/8551/8142/files/appwtl_16185dea-19ad-4035-8888-173b65adbc6b.png?v=1762265456', link:'https://wisecar.com.tr/products/wisecar-wtl-yapay-zeka-destekli-akilli-elektrikli-arac-sarj-cihazi-22-kw-mobil-uygulama-wisecar-ai'},
    // 22 kW TAŞINABİLİR — flagship: WTP3 (her zaman önerilen taşınabilir)
    {name:'WiseCar WTP3 22 kW',   power_kw:22,  tier:22,  flagship:true,  portable:true,  image_url:'https://cdn.shopify.com/s/files/1/0858/8551/8142/files/appwtp3.png?v=1762757812', link:'https://wisecar.com.tr/products/wisecar-22-kw-tasinabilir-elektrikli-arac-sarj-cihazi-wtp3'},
    {name:'WiseCar Facile 22 kW', power_kw:22,  tier:22,  flagship:false, portable:true,  image_url:'https://wisecar.com.tr/cdn/shop/files/Adsiz_tasarim_7a395ada-870b-4770-85bf-5005faac49bc.png?v=1781176911', link:'https://wisecar.com.tr/products/wisecar-facile-22-kw-32a-mobil-uygulamali-elektrikli-arac-sarj-cihazi-wifi-bluetooth-tasinabilir'},
    {name:'WiseCar WTPS3 22 kW',  power_kw:22,  tier:22,  flagship:false, portable:true,  image_url:'https://wisecar.com.tr/cdn/shop/files/WhatsAppGorsel2024-03-12saat15.34.39_bfe0e795.jpg?v=1755263479&width=713', link:'https://wisecar.com.tr/products/wisecar-wtps3-22-kw-tasinabilir-elektrikli-arac-sarj-cihazi'},
    // Düşük güç taşınabilir
    {name:'WiseCar WTP1 7.4 kW',  power_kw:7.4, tier:7.4, flagship:true,  portable:true,  image_url:'https://wisecar.com.tr/cdn/shop/files/WhatsApp_Image_2025-03-14_at_16.22.33.jpg?v=1744374581&width=713', link:'https://wisecar.com.tr/products/kopya-wisecar-wtp1-7-4-kw-tasinabilir-elektrikli-arac-sarj-cihazi'},
    {name:'WiseCar WTP1 3.5 kW',  power_kw:3.5, tier:3.5, flagship:true,  portable:true,  image_url:'https://wisecar.com.tr/cdn/shop/files/WhatsAppGorsel2024-06-14saat12.04.26_b4d71634.jpg?v=1741350478&width=713', link:'https://wisecar.com.tr/products/wisecar-wtp1-3-5-kw-tasinabilir-elektrikli-arac-sarj-cihazi'}
  ];

  const PHASE = {
    single:  {label:'Tek Faz (≤7,4 kW)', limit:7.4},
    three:   {label:'Üç Faz (≤22 kW)',   limit:22},
    unknown: {label:'Tesisat: belirsiz', limit:22}    // belirsiz: tüm cihazları göster
  };

  const EFF = 0.90;            // şarj verimliliği (AC kayıpları)

  /* --- Menzil & kıyas varsayımları (güncel değerlerle düzenleyin) --- */
  const EFF_KWH    = 17.5;     // araç ortalama tüketim kWh/100km (araçta 'ef' varsa o kullanılır)
  const SOCKET_KW  = 2.3;      // normal ev prizi (schuko ~10A) gücü

  const STORE_KEY = 'wc_state_v2';
  // İLERİDE: Gemini'yi güvenli kullanmak için kendi proxy endpoint'ini buraya koy
  // (key ASLA client'ta olmamalı). Boşsa yerel akıllı öneri motoru çalışır.
  const AI_PROXY_URL = '';

  /* ===== STATE ===== */
  let selCar = null, selCharger = null, selPhase = null, aiTimer = null;

  const $ = id => document.getElementById(id);
  const hide = el => el.classList.add('wc-hidden');
  const show = el => el.classList.remove('wc-hidden');
  const esc = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  /* ===== Analytics (varsa gönderir, yoksa sessiz) ===== */
  function track(event, data){
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({event:'wc_'+event}, data||{}));
      if (typeof window.gtag === 'function') window.gtag('event', 'wc_'+event, data||{});
      if (typeof window.fbq === 'function') window.fbq('trackCustom', 'WC_'+event, data||{});
    } catch(e){}
  }

  /* ===== Navigation ===== */
  function setSteps(n){
    document.querySelectorAll('#wc-steps .wc-step').forEach(el=>{
      const s = +el.dataset.step;
      el.classList.toggle('active', s === n);
      el.classList.toggle('done', s < n);
    });
  }
  function go(n){
    [1,2,3,4,5].forEach(i => hide($('wc-s'+i)));
    show($('wc-s'+n));
    // step indicator: s1+s2 => Araç, s3 => Tesisat, s4(cihaz)+s5(sonuç) => Cihaz
    setSteps(n<=2 ? 1 : (n===3 ? 2 : 3));
    $('wc-app').scrollIntoView({behavior:'smooth', block:'start'});
  }

  function reset(){
    selCar = selPhase = selCharger = null;
    try { localStorage.removeItem(STORE_KEY); } catch(e){}
    go(1);
  }

  /* ===== Render: brands ===== */
  const SORTED = EV_DB.slice().sort((a,b)=>a.brand.localeCompare(b.brand,'tr'));
  function renderBrands(filter){
    const f = (filter||'').toLocaleLowerCase('tr');
    const list = f ? SORTED.filter(b=>b.brand.toLocaleLowerCase('tr').includes(f)) : SORTED;
    $('wc-brands').innerHTML = list.map(b=>`
      <button class="wc-card" type="button" data-brand="${esc(b.brand)}">
        <img src="${b.logo}" alt="${esc(b.brand)}" loading="lazy" onerror="this.onerror=null;this.src='${lg(b.brand)}'">
        <span class="wc-card-title">${esc(b.brand)}</span>
      </button>`).join('') || `<p style="grid-column:1/-1;text-align:center;color:#86868b;">Sonuç bulunamadı.</p>`;
  }

  function selBrand(name){
    const b = EV_DB.find(x=>x.brand===name);
    if(!b) return;
    track('select_brand', {brand:name});
    $('wc-models').innerHTML = b.models.map((m,i)=>`
      <button class="wc-card" type="button" data-brand="${esc(name)}" data-model="${i}">
        <img src="${m.img}" alt="${esc(m.name)}" loading="lazy" onerror="this.src='${b.logo}'">
        <span class="wc-card-title">${esc(m.name)}</span>
        <span class="wc-card-sub">${m.bat} kWh · ${m.ac} kW AC</span>
      </button>`).join('');
    go(2);
  }

  function selModel(name, idx){
    const b = EV_DB.find(x=>x.brand===name);
    selCar = Object.assign({}, b.models[idx], {brand:name});
    track('select_model', {brand:name, model:selCar.name, battery:selCar.bat});
    go(3); // → tesisat sorusu
  }

  /* ===== Recommendation engine ===== */
  function usablePower(){ return Math.min(selCar.ac, PHASE[selPhase].limit); }

  // Tesisatın izin verdiği en yüksek cihaz sınıfı (tek faz => 7.4, üç faz => 22)
  function phaseTierMax(){ return PHASE[selPhase].limit >= 22 ? 22 : 7.4; }

  // O tesisatla uyumlu tüm WiseCar cihazları
  function compatibleChargers(){
    const max = phaseTierMax();
    return CHARGERS.filter(c => c.tier <= max);
  }

  // Aracın gücüne uygun cihaz sınıfı
  function recommendedTier(){
    const usable = usablePower();
    let tier = usable >= 11 ? 22 : (usable >= 7 ? 7.4 : 3.5);
    if(tier > phaseTierMax()) tier = phaseTierMax();
    return tier;
  }
  // Önerilen cihaz(lar): 22 kW'da hem duvar (WTA) hem taşınabilir (WTP3) flagship
  function recommendedList(){
    const tier = recommendedTier();
    const recs = CHARGERS.filter(c => c.tier===tier && c.flagship);
    return recs.length ? recs : CHARGERS.filter(c => c.tier===tier).slice(0,1);
  }
  function recommendedCharger(){ return recommendedList()[0]; } // tekil: birincil (duvar) öneri

  function reasonText(c){
    if(c.tier===22) return 'Üç fazlı tesisatınızla aracınızı en yüksek güçte doldurur.';
    if(c.tier===7.4) return 'Aracınız ve tesisatınız için en dengeli, hızlı ev şarjı.';
    return 'Taşınabilir ve ekonomik — günlük şarj için pratik çözüm.';
  }

  // Ürün özellik rozetleri (bilinen, güvenli özellikler)
  function chargerFeatures(c){
    const f = [c.power_kw + ' kW güç', 'Type 2 konnektör', c.portable ? 'Taşınabilir' : 'Duvar tipi (Wallbox)'];
    if(/WTL/.test(c.name)) f.push('WiseCar AI mobil uygulama');
    return f;
  }

  function selPhaseFn(p){
    selPhase = p;
    selCharger = null;
    track('select_phase', {phase:p});
    renderChargerChoice();
    go(4);
  }

  /* ===== Cihaz seçim ekranı (tesisata göre filtreli) ===== */
  function renderChargerChoice(){
    const list = compatibleChargers().slice();
    const recs = recommendedList();
    const isRec = c => recs.indexOf(c) !== -1;
    // önerilen(ler) en başa, sonra güce göre azalan
    list.sort((a,b)=> (isRec(b)?1:0)-(isRec(a)?1:0) || b.power_kw-a.power_kw);
    $('wc-charger-sub').textContent =
      selPhase==='three'
        ? 'Üç fazlı tesisatınızla tüm güç sınıfları uyumlu. ✓ Önerilen, aracınız için en verimli seçimdir.'
        : selPhase==='single'
        ? 'Tek fazlı tesisat ~7,4 kW ile sınırlıdır; yalnızca uyumlu cihazları gösteriyoruz. ✓ Önerilen, aracınız için en uygunudur.'
        : 'Tesisatınızı bilmediğiniz için tüm WiseCar cihazlarını gösteriyoruz. ✓ Önerilen, aracınız için en verimli olandır. (Üç fazınız yoksa 22 kW cihaz evde ~7,4 kW çalışır.)';
    $('wc-chargers').innerHTML = list.map(c=>`
      <button class="wc-card wc-charger-card${isRec(c)?' is-reco':''}" type="button" data-charger="${esc(c.name)}">
        ${isRec(c)?'<span class="wc-reco-tag">✓ Önerilen</span>':''}
        <img src="${c.image_url}" alt="${esc(c.name)}" loading="lazy">
        <span class="wc-card-title">${esc(c.name)}</span>
        <span class="wc-card-sub">${c.power_kw} kW${c.portable?' · taşınabilir':''}</span>
      </button>`).join('');
  }

  function selChargerFn(name){
    selCharger = CHARGERS.find(c=>c.name===name);
    if(!selCharger) return;
    const isReco = recommendedList().indexOf(selCharger) !== -1;
    track('select_charger', {charger:name, phase:selPhase, recommended:isReco});
    renderDashboard();
    go(5);
  }

  /* ===== Dashboard ===== */
  function renderDashboard(){
    $('wc-res-car').textContent = selCar.brand + ' ' + selCar.name;
    $('wc-res-dev').textContent = 'Cihaz: ' + selCharger.name;
    $('wc-res-img').src = selCar.img;
    $('wc-res-img').alt = selCar.brand + ' ' + selCar.name;
    $('wc-tech-bat').textContent = selCar.bat + ' kWh';
    $('wc-tech-pow').textContent = selCar.ac + ' kW';
    $('wc-tech-phase').textContent = PHASE[selPhase].label;

    // seçilen ürün kartı (vurgulu)
    $('wc-prod-name').textContent = selCharger.name;
    $('wc-prod-tagline').textContent = selCar.brand + ' ' + selCar.name + ' için ideal seçim — ' + reasonText(selCharger).toLocaleLowerCase('tr');
    $('wc-prod-img').src = selCharger.image_url;
    $('wc-prod-img').alt = selCharger.name;
    $('wc-prod-features').innerHTML = chargerFeatures(selCharger).map(f=>`<li>✓ ${esc(f)}</li>`).join('');
    $('wc-prod-link').href = selCharger.link;
    $('wc-prod-buy').href = selCharger.link;

    // diğer uyumlu cihazlar (seçilen hariç)
    const others = compatibleChargers().filter(c=>c!==selCharger);
    $('wc-alt-list').innerHTML = others.map(c=>`
      <a class="wc-alt-item" href="${c.link}" target="_blank" rel="noopener" data-alt="${esc(c.name)}">
        <img src="${c.image_url}" alt="${esc(c.name)}" loading="lazy">
        <span><span class="nm">${esc(c.name)}</span><br><span class="pw">${c.power_kw} kW${c.portable?' · taşınabilir':''}</span></span>
      </a>`).join('');

    track('view_result', {car:selCar.brand+' '+selCar.name, charger:selCharger.name, phase:selPhase});
    save();
    calc();
  }

  function calc(){
    const s = +$('in-start').value, e = +$('in-end').value, p = parseFloat($('in-price').value);
    $('lbl-start').textContent = s+'%';
    $('lbl-end').textContent = e+'%';
    $('lbl-price').textContent = p;

    const bar = $('wc-bar-fill'), txt = $('wc-bar-txt');
    if(s >= e){
      bar.style.width='0%'; bar.style.backgroundImage='none'; bar.style.background='#ff3b30';
      txt.textContent='Hatalı aralık'; $('wc-val-time').textContent='--:--'; $('wc-val-cost').textContent='-';
      ['wc-val-range','wc-speed-slow','wc-speed-fast','wc-speed-x'].forEach(id=>$(id).textContent='-');
      return;
    }
    bar.style.left = s+'%'; bar.style.width = (e-s)+'%';
    bar.style.backgroundImage = 'linear-gradient(90deg,#32d74b,#28cd41)';
    txt.textContent = s+'% → '+e+'%';

    const need = selCar.bat * ((e-s)/100);
    const pow  = Math.min(selCar.ac, selCharger.power_kw, PHASE[selPhase].limit);
    const hrs  = need / (pow * EFF);
    const h = Math.floor(hrs), m = Math.round((hrs-h)*60);
    const cost = need * p;

    $('wc-val-time').textContent = h + ':' + (m<10?'0'+m:m);
    $('wc-val-cost').textContent = cost.toFixed(2) + ' ₺';

    /* --- Kazanılan menzil --- */
    const eff = selCar.ef || EFF_KWH;
    const km = need * 100 / eff;                         // bu şarjla kazanılan menzil
    $('wc-val-range').textContent = '~' + Math.round(km).toLocaleString('tr-TR') + ' km';

    /* --- Ev prizine kıyasla hız --- */
    const socketHrs = need / (SOCKET_KW * EFF);
    const sh = Math.floor(socketHrs), sm = Math.round((socketHrs-sh)*60);
    $('wc-speed-slow').textContent = sh + ':' + (sm<10?'0'+sm:sm);
    $('wc-speed-fast').textContent = h + ':' + (m<10?'0'+m:m);
    $('wc-speed-name').textContent = '⚡ ' + (selCharger.power_kw) + ' kW';
    const ratio = pow / SOCKET_KW;
    $('wc-speed-x').textContent = ratio.toFixed(1).replace('.', ',');
    $('wc-speed-bar-slow').style.width = Math.max(5, (SOCKET_KW/pow)*100) + '%';

    clearTimeout(aiTimer);
    aiTimer = setTimeout(()=>askAI(h, m, cost.toFixed(2)), 900);
    save();
  }

  /* ===== AI / akıllı öneri ===== */
  function smartMessage(h, m, c){
    const tot = h + m/60;
    const name = selCar.brand;
    const dev = selCharger.name;
    if(selPhase==='three' && selCharger.tier===22)
      return `🚀 Üç fazlı tesisatınızla ${dev}, ${name} aracınızı tam hızında doldurur — sadece ${h} saat ${m} dk. Şehrin en hızlı ev şarjı sizde!`;
    if(selPhase==='single' && selCar.ac>=11)
      return `💡 Aracınız 11 kW destekliyor ama tek fazlı tesisatta ~7,4 kW'a iner. ${dev} bu tesisat için en doğru seçim — üç faza geçerseniz 22 kW cihazla süreyi yarıya indirebilirsiniz. ⚡`;
    if(tot > 8)
      return `🌙 ${name} bataryası büyük; ${h} saatlik dolum gece takıp sabah tam dolu çıkmak için ideal. Sadece ${c} ₺!`;
    if(tot < 3.5)
      return `⚡️ Harika hız! ${dev} ile ${name} sadece ${h} sa ${m} dk'da hazır. Mükemmel uyum!`;
    return `✅ Dengeli bir sonuç: ${name} aracınız ${c} ₺ maliyetle doluyor. ${dev} bu iş için tam isabet.`;
  }

  async function askAI(h, m, c){
    const box = $('wc-ai-txt');
    const fallback = smartMessage(h, m, c);
    if(!AI_PROXY_URL){ box.textContent = fallback; return; }   // proxy yoksa yerel motor
    box.style.opacity = .5;
    try{
      const r = await fetch(AI_PROXY_URL, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({car:selCar.brand+' '+selCar.name, charger:selCharger.name, hours:h, mins:m, cost:c, phase:selPhase})
      });
      if(!r.ok) throw 0;
      const d = await r.json();
      box.textContent = (d && d.text) ? d.text : fallback;
    }catch(e){ box.textContent = fallback; }
    box.style.opacity = 1;
  }

  /* ===== Persist ===== */
  function save(){
    try{
      localStorage.setItem(STORE_KEY, JSON.stringify({
        brand:selCar&&selCar.brand, model:selCar&&selCar.name, phase:selPhase,
        charger:selCharger&&selCharger.name,
        s:$('in-start').value, e:$('in-end').value, p:$('in-price').value
      }));
    }catch(e){}
  }
  function restore(){
    let st; try{ st = JSON.parse(localStorage.getItem(STORE_KEY)||'null'); }catch(e){ st=null; }
    if(!st || !st.brand || !st.model || !st.phase) return false;
    const b = EV_DB.find(x=>x.brand===st.brand); if(!b) return false;
    const idx = b.models.findIndex(m=>m.name===st.model); if(idx<0) return false;
    selCar = Object.assign({}, b.models[idx], {brand:st.brand});
    selPhase = PHASE[st.phase] ? st.phase : 'unknown';
    selCharger = CHARGERS.find(c=>c.name===st.charger) || recommendedCharger();
    if(st.s) $('in-start').value = st.s;
    if(st.e) $('in-end').value = st.e;
    if(st.p) $('in-price').value = st.p;
    renderDashboard();
    go(5);
    return true;
  }

  /* ===== Event delegation ===== */
  $('wc-app').addEventListener('click', function(ev){
    const t = ev.target.closest('[data-brand],[data-go],[data-phase],[data-charger],[data-alt],#wc-reset,#wc-prod-link,#wc-prod-buy');
    if(!t) return;
    if(t.id==='wc-reset'){ reset(); return; }
    if(t.dataset.go){ go(+t.dataset.go); return; }
    if(t.dataset.phase){ selPhaseFn(t.dataset.phase); return; }
    if(t.dataset.charger){ selChargerFn(t.dataset.charger); return; }
    if(t.dataset.alt){ track('select_alternative', {charger:t.dataset.alt}); return; } // link kendi açılır
    if(t.id==='wc-prod-buy'){ track('click_buy', {charger:selCharger&&selCharger.name}); return; }
    if(t.id==='wc-prod-link'){ track('click_product', {charger:selCharger&&selCharger.name}); return; }
    if(t.dataset.model!==undefined){ selModel(t.dataset.brand, +t.dataset.model); return; }
    if(t.dataset.brand){ selBrand(t.dataset.brand); return; }
  });

  $('wc-brand-search').addEventListener('input', e=>renderBrands(e.target.value));
  ['in-start','in-end','in-price'].forEach(id=>$(id).addEventListener('input', calc));

  /* ===== Init ===== */
  renderBrands('');
  setSteps(1);
  restore(); // varsa kullanıcıyı kaldığı yerden devam ettir

})();